import React from 'react';
import { render, hydrate } from 'react-dom';
import './index.css';
import './bootstrap_grid.css';
import App from './app';
import * as serviceWorker from './service_worker';

const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
